import React from "react";
import { Search } from "lucide-react";

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  ...props
}) => {
  return (
    <div className={["relative flex-grow sm:flex-grow-0 sm:w-48", className].join(" ")}>
      <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
        <Search size={14} className="text-ink-500" />
      </span>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{ paddingLeft: "2.25rem", paddingRight: "1rem" }}
        className="w-full py-1.5 text-xs font-semibold rounded-full border border-border bg-white text-ink-700 placeholder-ink-400 focus:outline-none focus:border-[#004BB5] focus:ring-1 focus:ring-[#004BB5]"
        {...props}
      />
    </div>
  );
};

export default SearchInput;
